<input
  tooltip="{{ model }}"
  [(ngModel)]="model"
  [typeahead]="classes"
  [typeaheadOptionsLimit]="9999"
  [typeaheadMinLength]="0"
  [typeaheadItemTemplate]="classSelectorTemplate"
  typeaheadOptionField="name"
  (typeaheadOnSelect)="classSelected($event)"
  placeholder="Choose Class"
  class="form-control chevron"
/>
<ng-template #classSelectorTemplate let-model="item" let-index="index">
  <div class="qb-accounts-item">
    <div class="name" title="{{ model.name }}">{{ model.name }}</div>
  </div>
</ng-template>
